import React, { useEffect } from "react";

const RectangularOffersSlider = ({
  title,
  products,
  sliderClass = "tf-sw-product-sell-1",
  showTitle = true,
}) => {
  useEffect(() => {
    // Wait for DOM to be ready and Swiper to be available
    const initializeSlider = () => {
      if (!window.Swiper) {
        console.log("Swiper not available yet, retrying...");
        setTimeout(initializeSlider, 100);
        return;
      }

      // Initialize RectangularOffersSlider
      if (
        document.querySelector(`.${sliderClass}`) &&
        !document.querySelector(`.${sliderClass}`).swiper
      ) {
        console.log(`Initializing ${sliderClass}...`);
        const sliderElement = document.querySelector(`.${sliderClass}`);
        const preview = parseFloat(sliderElement.dataset.preview) || 4.6;
        const tablet = parseFloat(sliderElement.dataset.tablet) || 2.6;
        const mobile = parseFloat(sliderElement.dataset.mobile) || 1.6;
        const spacingLg = parseInt(sliderElement.dataset.spaceLg) || 30;
        const spacingMd = parseInt(sliderElement.dataset.spaceMd) || 15;
        const perGroup = parseInt(sliderElement.dataset.pagination) || 1;
        const perGroupMd = parseInt(sliderElement.dataset.paginationMd) || 1;
        const perGroupLg = parseInt(sliderElement.dataset.paginationLg) || 1;

        // Get navigation selectors based on slider class
        const navNextSelector =
          sliderClass === "tf-sw-product-sell-1"
            ? ".nav-next-sell-1"
            : sliderClass === "tf-sw-product-sell-basin"
            ? ".nav-next-basin"
            : sliderClass === "tf-sw-product-sell-black"
            ? ".nav-next-black"
            : ".nav-next-sell-1";
        const navPrevSelector =
          sliderClass === "tf-sw-product-sell-1"
            ? ".nav-prev-sell-1"
            : sliderClass === "tf-sw-product-sell-basin"
            ? ".nav-prev-basin"
            : sliderClass === "tf-sw-product-sell-black"
            ? ".nav-prev-black"
            : ".nav-prev-sell-1";

        new window.Swiper(`.${sliderClass}`, {
          slidesPerView: mobile,
          spaceBetween: spacingMd,
          speed: 1000,
          pagination: {
            el: `.sw-pagination-${sliderClass.replace(
              "tf-sw-product-sell-",
              ""
            )}`,
            clickable: true,
          },
          slidesPerGroup: perGroup,
          navigation: {
            clickable: true,
            nextEl: navNextSelector,
            prevEl: navPrevSelector,
          },
          breakpoints: {
            768: {
              slidesPerView: preview,
              spaceBetween: spacingLg,
              slidesPerGroup: perGroupLg,
            },
            1150: {
              slidesPerView: preview,
              spaceBetween: spacingLg,
              slidesPerGroup: perGroupLg,
            },
          },
        });
        console.log(`${sliderClass} initialized successfully`);
      }
    };

    initializeSlider();
  }, [sliderClass]);

  return (
    <>
      <style>
        {`
          /* Maximum width constraint for rectangular offers slider */
          .flat-spacing-27-edit {
            max-width: 1600px !important;
            margin: 0 auto !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
            box-sizing: border-box !important;
          }

          @media (max-width: 575px) {
            .flat-spacing-27-edit {
              max-width: 100% !important;
              padding-left: 12px !important;
              padding-right: 12px !important;
            }
          }

          @media (min-width: 576px) and (max-width: 767px) {
            .flat-spacing-27-edit {
              max-width: 100% !important;
              padding-left: 16px !important;
              padding-right: 16px !important;
            }
          }

          @media (min-width: 768px) and (max-width: 991px) {
            .flat-spacing-27-edit {
              max-width: 1200px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 992px) and (max-width: 1199px) {
            .flat-spacing-27-edit {
              max-width: 1400px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 1400px) {
            .flat-spacing-27-edit {
              max-width: 1600px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          /* Blue hover effect for product titles */
          .collection-item-v3 .collection-content .title {
            transition: color 0.3s ease;
          }
          
          .collection-item-v3:hover .collection-content .title {
            color: #0e5aa7 !important;
          }
          
          /* Remove all bottom margins and padding */
          .flat-spacing-27-edit {
            margin-bottom: 0 !important;
            padding-bottom: 0 !important;
          }
          
          /* Hide arrow icons on slider items */
          .${sliderClass} .collection-item-v3 .collection-image .box-icon {
            display: none !important;
          }
          
          .${sliderClass} .collection-item-v3 .collection-image::before,
          .${sliderClass} .collection-item-v3 .collection-image::after {
            display: none !important;
          }
          
          /* Make bluish border always visible */
          .${sliderClass} .collection-item-v3 .collection-image {
            border-color: #0e5aa7 !important;
            outline-color: #0e5aa7 !important;
            outline: 1px solid #0e5aa7 !important;
            border: 1px solid #0e5aa7 !important;
          }
          
          /* Enhance border on hover */
          .${sliderClass} .collection-item-v3:hover .collection-image,
          .${sliderClass} .collection-item-v3 .collection-image:hover,
          .${sliderClass} .collection-item-v3 .collection-image:focus,
          .${sliderClass} .collection-item-v3 .collection-image:focus-visible {
            border-color: #0a4a8a !important;
            outline-color: #0a4a8a !important;
            outline: 2px solid #0a4a8a !important;
            border: 2px solid #0a4a8a !important;
          }
          
          /* Increase height to accommodate text */
          .${sliderClass} .swiper-slide {
            height: auto !important;
          }
          
          .${sliderClass} .collection-item-v3 {
            display: flex;
            flex-direction: column;
            height: 100%;
            min-height: 160px;
          }
          
          .${sliderClass} .collection-item-v3 .collection-image {
            flex-shrink: 0;
          }
          
          .${sliderClass} .collection-item-v3 .collection-content {
            flex: 1;
            display: flex;
            align-items: center;
            min-height: 40px;
            padding: 6px 12px;
            margin-top: 0 !important;
            padding-top: 2px !important;
          }
          
          .${sliderClass} .collection-item-v3 .collection-image {
            margin-bottom: 0 !important;
            padding-bottom: 0 !important;
          }
        
        `}
      </style>
      <section
        className="flat-spacing-27-edit"
        style={{ paddingTop: "20px", paddingBottom: "0px" }}
      >
        <div className="container">
          <div
            className="flat-title flex-row justify-content-between px-0"
            style={{ marginBottom: "24px" }}
          >
            {showTitle && title && (
              <span
                className="title wow fadeInUp text_green-1"
                data-wow-delay="0s"
                style={{ fontSize: "1.6rem", fontWeight: "600" }}
              >
                {title}
              </span>
            )}
            {/* <div className="box-sw-navigation">
              <div
                className={`nav-sw round ${
                  sliderClass === 'tf-sw-product-sell-1'
                    ? 'nav-next-sell-1'
                    : sliderClass === 'tf-sw-product-sell-basin'
                    ? 'nav-next-basin'
                    : sliderClass === 'tf-sw-product-sell-black'
                    ? 'nav-next-black'
                    : 'nav-next-sell-1'
                } nav-next-slider`}
              >
                <span className="icon icon-arrow-left"></span>
              </div>
              <div
                className={`nav-sw round ${
                  sliderClass === 'tf-sw-product-sell-1'
                    ? 'nav-prev-sell-1'
                    : sliderClass === 'tf-sw-product-sell-basin'
                    ? 'nav-prev-basin'
                    : sliderClass === 'tf-sw-product-sell-black'
                    ? 'nav-prev-black'
                    : 'nav-prev-sell-1'
                } nav-prev-slider`}
              >
                <span className="icon icon-arrow-right"></span>
              </div>
            </div> */}
          </div>
        </div>
        <div className="container-full slider-layout-right">
          <div
            dir="ltr"
            className={`swiper ${sliderClass} sw-wrapper-right`}
            data-preview="4.6"
            data-tablet="2.6"
            data-mobile="1.6"
            data-space-lg="30"
            data-space-md="15"
            data-pagination="1"
            data-pagination-md="1"
            data-pagination-lg="1"
          >
            <div className="swiper-wrapper">
              {products.map((product, index) => (
                <div key={index} className="swiper-slide">
                  <div className="collection-item-v3 hover-img">
                    <a
                      href={product.link || "/shop-collection-sub"}
                      className="collection-image img-style"
                    >
                      <img src={product.image} alt={product.name} />
                    </a>
                    <div className="collection-content collection-content-before ">
                      <a
                        href={product.link || "/shop-collection-sub"}
                        className="link title fw-5 text_green-1"
                      >
                        {product.name}
                      </a>
                      {/* <div className="count text_black-2">
                      {product.count || "0 items"}
                    </div> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RectangularOffersSlider;
